import '@angular/compiler';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { ComponentChatComponent } from './component.chat/component.chat.component';
import { ComponentJoystickComponent } from './component.joystick/component.joystick.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { ComponentSidemenuComponent } from './component.sidemenu/component.sidemenu.component';
import { ComponentToastComponent } from './component.toast/component.toast.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { ComponentMinimapComponent } from './component.minimap/component.minimap.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { ComponentContextmenuComponent } from './component.contextmenu/component.contextmenu.component';
import { ComponentNoteComponent } from './component.note/component.note.component';
import { ComponentModalComponent } from './component.modal/component.modal.component';
import { ComponentCenterswitcherComponent } from './component.centerswitcher/component.centerswitcher.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { ComponentCharacterComponent } from './component.character/component.character.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { ComponentOnlinepanelComponent } from './component.onlinepanel/component.onlinepanel.component';
import { PageCenterRoomComponent } from './page.center.room/page.center.room.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            },
            {
                "path": "",
                component: PageMainComponent,
                "app_id": "page.main"
            },
            {
                "path": "center/:room",
                component: PageCenterRoomComponent,
                "app_id": "page.center.room"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }